var recaptchaButtonCallback = function (token) {
    $(".button-macro__captcha-error").hide();
}

var validateRecaptcha = function (e) {
    var response = grecaptcha.getResponse();

    if (response === "") {
        $(".button-macro__captcha-error", e.target).show();
        return false;
    }

    return true;
}